/*
  将@多人的方法提取出来，方便其他组件调用

  HTML DEMO:
    <div class="comment-box">
      <textarea
        v-model="textarea"
        ref="textArea"
        placeholder="输入回复内容..."
        @keyup="mention">
      </textarea>
      <div class="mention-result" v-show="mentionList.length">
        <ul>
          <li class="first">
            <span class="text">选择你要@的人</span>
          </li>
          <li
            class="me-item"
            v-for="(item, index) in mentionList"
            :class="{actived: Mcurrent === index}"
            @click="selectMention(item)"
            @mouseover="changeCurrent(index)">
            <span class="text">{{item.value}}</span>
          </li>
        </ul>
      </div>
      <div class="btn-group">
        <el-button size="small" type="primary">回 复</el-button>
      </div>
    </div>
 */
import * as api from 'src/api'

let mLoc = 0
let lazy

export default {
  props: {
    defUserId: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      refName: '',
      textarea: '',
      // @某人时的员工列表数据
      mentionList: [],
      Mcurrent: 0,
      refUserId: this.defUserId
    }
  },

  methods: {

    // 监听文本框的keyup事件
    mention () {
      if (!this.refUserId) {
        let val = this.textarea
        if ((val && val.slice(-1) === '@') && this.checkAt(val)) {
          mLoc = val.length
        }
        if (!val || val.indexOf('@') === -1) mLoc = 0

        if (mLoc) {
          let key = val.slice(mLoc)
          this.getStaff(key)
        } else {
          this.mentionList = []
        }
      } else {
        // 如果用户手动删除了
        let location = this.textarea.indexOf(this.refName)
        if (location === -1) {
          this.refUserId = ''
          this.refName = ''
        }
      }
    },
    // 检查是否只有一个@
    checkAt (str) {
      let i = str.indexOf('@')
      if (str.length - i === 1) {
        return true
      } else {
        return false
      }
    },
    getStaff (key) {
      clearTimeout(lazy)
      lazy = setTimeout(() => {
        let url = '/user/getStaffsAjax.html'
        let params = {
          pageSize: 10,
          nameLike: key || ''
        }
        api.post(url, params, (data) => {
          this.mentionList = data.result
        })
      }, 200)
    },
    // 选中要@的人
    selectMention (item) {
      this.refUserId = item.id
      // 将客户输入的人名替换为数据库的人名
      let val = this.textarea
      let i = val.lastIndexOf('@')
      let str = val.slice(i + 1)
      if (str) {
        this.textarea = val.replace(str, (item.value + ' '))
      } else {
        this.textarea = val + item.value + ' '
      }
      this.refName = `@${item.value} `
      // 清空下拉列表，并将光标移回文本框
      this.mentionList = []
      this.$refs.textArea.focus()
    },
    changeCurrent (index) {
      this.Mcurrent = index
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/common/comment-box/at-someone.js